import { LinkedAccount } from './LinkedAccount';
import { LinkedAccount as LinkedAccountType } from '../../modals/BankSelectionModal/getLinkedAccounts';

export const LinkedAccountsList = ({
    accounts
}: {
    accounts: LinkedAccountType[];
}) => (
    <div data-testid="truelayerLinkedAccounts" className="mb-l space-y-s">
        {accounts.map((account) => (
            <LinkedAccount key={account.accountId} account={account} />
        ))}
    </div>
);
